import { render, staticRenderFns } from "./RecentlyFiledMobile.vue?vue&type=template&id=1a19eb06"
import script from "./RecentlyFiledMobile.vue?vue&type=script&lang=js"
export * from "./RecentlyFiledMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports